import { createAction } from 'redux-actions';
import { SET_NAV_NODE, SET_EXPIRENCE_TYPE, LOAD_NAV_DATA } from './constants';

export const fetchNavData = createAction(LOAD_NAV_DATA.BOOT);

export const setNavData = createAction(LOAD_NAV_DATA.SUCCESS);

export const navDataFetchingError = createAction(LOAD_NAV_DATA.ERROR);

export const setNavNode = (node = {}) => {
  const payload = {};
  payload.code = node.code || '';
  if (node.app_behaviour) payload.appBehavior = JSON.parse(node.app_behaviour);
  else payload.appBehavior = {};
  if (
    payload.appBehavior.layout === 'playandgo' ||
    payload.code === 'playandgo'
  )
    payload.childs = node.childs;
  return { type: SET_NAV_NODE, payload };
};

export const setTypeNavigationExperience = type => ({
  type: SET_EXPIRENCE_TYPE,
  payload: type,
});

export const dispatchSetNavNode = node => dispatch =>
  dispatch(setNavNode(node));
